
import { Component, Injector, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { UserGroupHasOrganizationService, UserGroupHasUserService, UserGroupService } from 'tnx-admin-service/identityserver/usergroup/services';
import { CoCauToChucService, ComponentContextService, DataFormBase, DropdownControlSchema, EventData, FormSchemaBase, Operator, TextAreaControlSchema, TextControlSchema, UserPickerControlSchema, UserV5Service } from 'tnx-shared';

@Component({
    selector: 'usergroup-form',
    templateUrl: './usergroup-form.component.html',
    styleUrls: ['./usergroup-form.component.scss'],
    providers: [ComponentContextService],
})
export class UserGroupFormComponent extends DataFormBase implements OnInit {

    @ViewChild('organization', { static: true }) organizationRef: TemplateRef<any>;
    @ViewChild('organizationFilter', { static: true }) organizationFilterRef: TemplateRef<any>;

    searchSchema: any = {};

    constructor(
        protected _injector: Injector,
        private _userGroupService: UserGroupService,
        public _userV5Service: UserV5Service,
        public _organizationService: CoCauToChucService,
        private _coCauToChucService: CoCauToChucService,
        private _userGroupHasUserService: UserGroupHasUserService,
        private _userGroupHasOrganizationService: UserGroupHasOrganizationService
    ) {
        super(_injector);
    }

    ngOnInit() {
        super.ngOnInit();
        this.setting.baseService = this._userGroupService;
        this.setting.schema = <FormSchemaBase[]>[
            new TextControlSchema({
                field: 'code',
                label: 'Mã',
                required: true
            }),
            new TextControlSchema({
                field: 'name',
                label: 'Tên',
                required: true
            }),
            new TextAreaControlSchema({
                field: 'description',
                label: 'Mô tả',
                mdWidth: 12
            }),
            new UserPickerControlSchema({
                field: 'idsUser',
                label: 'Chọn người dùng',
                placeholder: 'Chọn người dùng',
                multiple: true,
                mdWidth: 12
            })
        ];

        this.initSearchSchema();
    }

    initSearchSchema() {
        this.searchSchema.idOrgranization = new DropdownControlSchema({
            field: 'idOrgranization',
            placeholder: 'Chọn đơn vị',
            baseService: this._organizationService,
            sortField: 'idDuongDan',
            fieldPlus: 'idDuongDan',
            isTree: true,
            fieldTree: 'idCha',
            valueParentRoot: this._commonService.guidEmpty(),
            // isServerLoad: true, Option này đang không chạy được trong case này
            loadOnInit: true,
            multiple: false
        })
    }

    async onFormInitialized(formEvent: EventData) {
    }

    async onFormEvent(evt) {
        console.log(evt);
    }

    async modifyDetailData(data) {
        // xử lý dữ liệu lấy từ get detail về
        const filters = [
            this.newFilter('groupId', Operator.equal, data.id)
        ];
        await this._userGroupHasUserService.getAll(filters, 'userId').then(rs => {
            if (rs.success) {
                data.idsUser = rs.data.map(x => x.userId);
            }
        })
    }

    async onAfterGetDetail() {
        // xử lý dữ liệu sau khi đã lấy từ api (sau cả event modifyDetailData) về và trước khi hiển thị ra view
    }

    onBeforeSave() {
        // trước khi lưu
    }
}

